import { EnvironmentSettingActions } from '../../constants';

export const setIsOpen = (isOpen) => ({
  type: EnvironmentSettingActions.SET_IS_OPEN,
  isOpen,
});

export const updateEnvironment = (embeddingType, envInfo) => ({
  type: EnvironmentSettingActions.UPDATE_ENV,
  embeddingType,
  envInfo,
});

export const updateUrl = (customUrl) => ({
  type: EnvironmentSettingActions.UPDATE_URL,
  customUrl,
});

export const updateUsername = (username) => ({
  type: EnvironmentSettingActions.UPDATE_USERNSME,
  username,
});

export const updatePassword = (password) => ({
  type: EnvironmentSettingActions.UPDATE_PASSWORD,
  password,
});

export const updateContentGroup = (contentGroup) => ({
  type: EnvironmentSettingActions.UPDATE_CONTENT_GROUP,
  contentGroup,
});
